module.exports = __webpack_public_path__ + "media/images/common/side_bg_mid-87605a60ef0498cc3f190662d4b55ab4.gif";